import { DatePicker } from '@material-ui/pickers';
import React from 'react';
import { YearCell } from '../../../utils/Cells';
import { useStyles } from '../styles/Styles';

export default function ErrorAwareYearPicker(props) {
    const classes = useStyles(props, "year")();

    const helperText = () => {
        if (props.errors && props.errors.has(props.name)) {
            return props.errors.get(props.name).huText;
        } else if (props.prevValue && props.value && props.value.getTime() !== new Date(props.prevValue).getTime()) {
            return <YearCell value={new Date(props.prevValue)} />;
        } else {
            return "";
        }
    }

    const isError = () => {
        if (props.errors) {
            return props.errors.has(props.name);
        } else {
            return false;
        }
    }

    const { prevValue, ...rest } = props;
    return (
        <DatePicker
            autoOk
            fullWidth
            error={isError()}
            helperText={helperText()}
            inputVariant="outlined"
            format="yyyy"
            openTo="year"
            views={["year"]}
            className={classes.root}
            FormHelperTextProps={{ className: "helper-text" }}
            {...rest} />
    )

};